import { render, staticRenderFns } from "./StayResearch.vue?vue&type=template&id=470481d5&"
import script from "./StayResearch.vue?vue&type=script&lang=js&"
export * from "./StayResearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports